import { getDefaultStore, useAtomValue } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { Step } from '../components/StepsList/StepsList';

export interface ProgressBarData {
  currentStep: number;
  steps: Step[];
  isComplete: boolean;
  background?: string;
}

const defaultProgressBarData: ProgressBarData = {
  currentStep: 0,
  steps: [],
  isComplete: false,
  background: undefined,
};

export const ProgressBarDataAtom = atomWithReset<ProgressBarData>(defaultProgressBarData);

export const useProgressBarData = () => {
  return useAtomValue(ProgressBarDataAtom);
};

export const setProgressBarData = (partialData: Partial<ProgressBarData>) => {
  const store = getDefaultStore();
  store.set(ProgressBarDataAtom, (prev) => ({
    ...prev,
    ...partialData,
  }));
};

export const resetProgressBarData = () => {
  const store = getDefaultStore();
  store.set(ProgressBarDataAtom, defaultProgressBarData);
};

// Helper functions for common operations
export const incrementStep = () => {
  const store = getDefaultStore();
  store.set(ProgressBarDataAtom, (prev) => {
    const nextStep = prev.currentStep + 1;
    const isComplete = nextStep >= prev.steps.length;
    return {
      ...prev,
      currentStep: isComplete ? prev.steps.length : nextStep,
      isComplete,
    };
  });
};

export const setSteps = (steps: Step[]) => {
  setProgressBarData({
    steps,
    currentStep: 0,
    isComplete: false,
  });
};
